import { createEventBusReducer } from 'hooks/eventBus';
const eventBus = createEventBusReducer();
export default eventBus;
